export default __webpack_public_path__ + "i18n/translations/translation-it.cfbb72e6.json";